interface PricingToggleProps {
  billingType: "Monthly" | "Quarterly" | "Yearly";
  setBillingType: (type: "Monthly" | "Quarterly" | "Yearly") => void;
}

export default function PricingToggle({
  billingType,
  setBillingType,
}: PricingToggleProps) {
  return (
    <section id="pricing" className="bg-white pt-4">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex justify-center">
          <div className="inline-flex items-center bg-[gray]/10 rounded-full p-1 shadow-inner">
            <button
              onClick={() => setBillingType("Monthly")}
              className={`px-8 py-3 rounded-full transition-all relative ${
                billingType === "Monthly"
                  ? "bg-white text-[#0B60D6] shadow-md"
                  : "text-[gray]/70 hover:text-[gray]"
              }`}
            >
              Monthly
              <span className="absolute -top-1 right-2 px-2 py-0.5 bg-primary text-white text-[8px] rounded-full">
                + 25%
              </span>
            </button>
            <button
              onClick={() => setBillingType("Quarterly")}
              className={`px-8 py-3 rounded-full transition-all relative ${
                billingType === "Quarterly"
                  ? "bg-white text-[#0B60D6] shadow-md"
                  : "text-[gray]/70 hover:text-[gray]"
              }`}
            >
              Quarterly
              <span className="absolute -top-1 right-2 px-2 py-0.5 bg-primary text-white text-[8px] rounded-full">
                + 15%
              </span>
            </button>
            <button
              onClick={() => setBillingType("Yearly")}
              className={`px-8 py-3 rounded-full transition-all relative ${
                billingType === "Yearly"
                  ? "bg-white text-[#0B60D6] shadow-md"
                  : "text-[gray]/70 hover:text-[gray]"
              }`}
            >
              Annual
              <span className="absolute -top-1 right-2 px-2 py-0.5 bg-primary text-white text-[8px] rounded-full">
                Best Value
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
